module.exports = __webpack_public_path__ + "static/media/mh.b4e4c149.svg";